<template>
  <div class="section">
    <div class="container">
      <div class="row row-split-content">
        <div class="content-width-medium">
          <h1>Login</h1>
          <div class="form-wrapper margin-top w-form">
            <form class="form" ms-login="true">
              <div class="form-group">
                <input
                  type="email"
                  class="form-input w-input"
                  maxlength="256"
                  name="email"
                  data-name="Email"
                  placeholder="Email Address"
                  id="email"
                  required
                  ms-field="email"
                />
              </div>

              <div class="form-group">
                <input
                  type="password"
                  class="form-input w-input"
                  maxlength="256"
                  name="password"
                  data-name="Password"
                  placeholder="Password"
                  id="company-name"
                  ms-field="company"
                />
              </div>
              <input
                type="submit"
                value="Sign In"
                data-wait="Please wait..."
                class="button w-button"
                data-membership-id="5e08febaaabc680017dfd539"
              />
            </form>
            <a ms-forgot="true" href="#">Forgot Password?</a>
            <div class="form-feedback bg-success w-form-done">
              <div>Thank you! Your submission has been received!</div>
            </div>
            <div class="form-feedback bg-error w-form-fail">
              <div>Oops! Something went wrong while submitting the form.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: "home",
  components: {},
  data() {
    return {
      content: []
    };
  },
  methods: {}

};
</script>
